import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ABOUT } from "@/lib/testIds";
import { ABOUT_CONTENT } from "@/data/staticContent";

export const About = () => {
  const c = ABOUT_CONTENT;
  return (
    <main data-testid={ABOUT.root} className="pb-24">
      {/* Hero */}
      <section
        data-testid={ABOUT.hero}
        className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-5 pt-20 md:grid-cols-12 md:gap-16 md:px-10 md:pt-32"
      >
        <div className="md:col-span-7">
          <p className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground md:text-xs">
            {c.eyebrow}
          </p>
          <h1 className="mt-5 font-display text-5xl font-medium leading-[0.95] tracking-tight md:mt-8 md:text-[9rem]">
            Slow travel,
            <br />
            <span className="italic">hand-picked</span>.
          </h1>
        </div>
        <div className="flex items-end md:col-span-5">
          <p className="text-base leading-relaxed text-foreground/80 md:text-lg">
            {c.lede}
          </p>
        </div>
      </section>

      {/* Big photo */}
      <section className="mx-auto mt-16 max-w-[1400px] px-5 md:mt-24 md:px-10">
        <div className="aspect-[16/8] w-full overflow-hidden bg-muted">
          <img
            src={c.storyImage}
            alt="A home in the StayEasy collection"
            className="h-full w-full object-cover"
          />
        </div>
      </section>

      {/* Numbers */}
      <section className="mx-auto mt-16 max-w-[1400px] px-5 md:mt-24 md:px-10">
        <div className="grid grid-cols-2 gap-8 border-y border-foreground/10 py-10 md:grid-cols-4 md:gap-10 md:py-14">
          {c.numbers.map((n) => (
            <div key={n.label}>
              <p className="font-display text-5xl font-medium tracking-tight md:text-6xl">
                {n.value}
              </p>
              <p className="mt-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:text-xs">
                {n.label}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Values */}
      <section className="mx-auto mt-20 max-w-[1400px] px-5 md:mt-32 md:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:text-xs">
          Values · Nº 01
        </p>
        <h2 className="mt-4 font-display text-4xl font-medium leading-[0.95] tracking-tight md:text-6xl">
          What we care about,
          <br />
          in <span className="italic">plain</span> words.
        </h2>
        <div className="mt-12 grid grid-cols-1 gap-x-10 gap-y-12 md:mt-16 md:grid-cols-3">
          {c.values.map((v, i) => (
            <div key={v.title}>
              <p className="text-[10px] uppercase tracking-[0.2em] text-primary md:text-xs">
                0{i + 1}
              </p>
              <h3 className="mt-4 font-display text-2xl font-medium leading-tight tracking-tight md:text-3xl">
                {v.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">
                {v.body}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto mt-24 max-w-[1400px] px-5 md:mt-32 md:px-10">
        <div className="flex flex-col items-start justify-between gap-6 border-t border-foreground/10 pt-10 md:flex-row md:items-end md:gap-10">
          <h3 className="font-display text-3xl font-medium leading-[1.05] tracking-tight md:text-5xl">
            Ready to find a
            <br />
            <span className="italic">quiet</span> one?
          </h3>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/properties"
              data-testid={ABOUT.cta + "-browse"}
              className="inline-flex items-center gap-2 rounded-full bg-foreground px-6 py-3 text-sm font-medium text-background transition-transform duration-300 hover:-translate-y-0.5"
            >
              Browse stays <ArrowRight size={16} />
            </Link>
            <Link
              to="/hosts/subscription"
              data-testid={ABOUT.cta + "-host"}
              className="inline-flex items-center gap-2 rounded-full border border-foreground/30 px-6 py-3 text-sm font-medium text-foreground transition-colors hover:border-foreground"
            >
              Become a host
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
